<button
  class="btn"
  *ngIf="data.tooltipUrl"
  [mtxTooltip]="imageTooltip"
  mtxTooltipPosition="below"
  matTooltipShowDelay="300"
>
  {{ data.label }}
</button>
<button
  class="btn"
  *ngIf="!data.tooltipUrl"
  (click)="onClick(data.type)"
>
  {{ data.label }}
</button>
<ng-template #imageTooltip>
  <img [src]="data.tooltipUrl" style="width: 50vw; height: 50vh" />
</ng-template>
